// src/plugins/vuetify.js
import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Vuetify 스타일 추가
import { aliases, mdi } from 'vuetify/iconsets/mdi'; // (선택) 아이콘 사용

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light', // 기본 테마 설정 (light 또는 dark)
  },
});